import { action } from "typesafe-actions";
import { IMyCommissionReport } from "./myCommissionReport.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { api } from "../../api/api";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../messages/messagesActions";

export const FETCH_MY_COMMISSION_REPORTS_LIST_PROGRESS =
  "FETCH_MY_COMMISSION_REPORTS_LIST_PROGRESS";
export const FETCH_MY_COMMISSION_REPORTS_LIST_SUCCESS =
  "FETCH_MY_COMMISSION_REPORTS_LIST_SUCCESS";
export const FETCH_MY_COMMISSION_REPORTS_LIST_FAILED =
  "FETCH_MY_COMMISSION_REPORTS_LIST_FAILED";

export const fetchMyCommissionReportsListProgress = () =>
  action(FETCH_MY_COMMISSION_REPORTS_LIST_PROGRESS);

export const fetchMyCommissionReportsListSuccess = (
  data: IMyCommissionReport[]
) => action(FETCH_MY_COMMISSION_REPORTS_LIST_SUCCESS, { data });

export const fetchMyCommissionReportsListFailed = (error: string) =>
  action(FETCH_MY_COMMISSION_REPORTS_LIST_FAILED, error);

export const fetchMyCommissionReportsAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    user_fact_id: number | null,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchMyCommissionReportsListProgress());
      let finalUrl = `/accounting/get-accn-my-commission-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}&user_fact_id=${user_fact_id}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-accn-my-commission-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IMyCommissionReport[] = res.data.data;

      dispatch(fetchMyCommissionReportsListSuccess(data));
    } catch (err: any) {
      dispatch(fetchMyCommissionReportsListFailed(err.message));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertMyCommissionReports =
  (
    data: IMyCommissionReport[],
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      await api.post("/accounting/edit-accn-my-commission-report", data);
      const message = "Commission report saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_MY_COMMISSION_REPORTS_STATE =
  "CLEAR_MY_COMMISSION_REPORTS_STATE";

export const clearMyCommissionReportsState = () =>
  action(CLEAR_MY_COMMISSION_REPORTS_STATE);
